function disableScroll() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    window.onscroll = function() {
        window.scrollTo(scrollLeft, scrollTop);
    };
}

function enableScroll() {
    window.onscroll = function() {};
}

export const getOrientation = () => {
    if (matchMedia('(orientation: landscape)').matches) {
        return 'landscape'
    }

    if (matchMedia('(orientation: portrait)').matches) {
        return 'portrait'
    }

    return '';
}

export const getTimestamp = () => {
    return (Math.floor(Date.now() / 1000));
}

export const getTimestampInMilliseconds = () => {
    return Date.now();
}

export const getTimestampInISO = () => {
    return (new Date()).toISOString();
}

export const getClientTimeOffset = (server) => {
    return getTimestamp() - server;
}

export const getClientTimeOffsetInMilliseconds = (server) => {
    return getTimestampInMilliseconds() - server;
}

export const trackPageFocusTime = () => {
    window.focusTime = 0;
    let interval;

    const start = () => interval = setInterval(() => window.focusTime++, 1000);
    const stop  = () => clearInterval(interval);

    window.onfocus = start;
    window.onblur  = stop;

    start();
}

export const makeButtonsVisible = () => {
    const buttons = document.querySelectorAll('a.invisible[data-action-delay]');
    if (!buttons) { return; }

    buttons.forEach((button) => {
        setTimeout(() => {
            button.classList.remove('invisible');
        }, button.getAttribute('data-action-delay') * 1000);
    });
}

export const getTime = (start) => {
    const now = new Date().getTime();
    const diff = start - now;

    if (diff < 0) {
        return null;
    }

    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return `${('0'+minutes).slice(-2)}:${('0'+seconds).slice(-2)}`;
}

export const dispatchEvent = (evt, args) => {
    args.modal.dispatchEvent(new CustomEvent(evt, { bubbles: true, detail: args }))
}

export const copyLinkToShare = () => {
    let links = document.querySelectorAll('.copy-share-link');

    if (links) {
        links.forEach(function(link) {
            let copied = link.querySelector('.copied-tooltip');

            link.addEventListener("click", (e) => {
                navigator.clipboard.writeText(link.parentElement.querySelector('.copy-share-input').value);
                copied.hidden = false;
                setTimeout(( () => copied.hidden = true), 2000);
            });

            link.addEventListener("mouseout", () => copied.hidden = true);
        });
    }
}

export const isElementVisible = (el) => {
    if (!el) return;

    return window.getComputedStyle(el).display === 'block';
}

export function isObject(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}

export function chartAutoProgress() {
    const chart = document.querySelector('.js-chart-progress');
    if (!chart) { return; }

    let chartProgress = setInterval(() => {
        if (chart.offsetWidth > 0 && chart.offsetHeight > 0) {
            clearInterval(chartProgress);
            chart.style.transform = `rotate(${chart.dataset.percentage}deg)`;
        }
    }, 100);
}

export function numberAutoCounter(id) {
    let counter = document.getElementById(id);
    if (!counter) { return; }

    const delay = 7000;
    setTimeout(function() {
        let num = Number(document.getElementById(id).innerHTML);
        incNbrRec(0, num, counter);
    }, delay);
}

function incNbrRec(i, num, section) {
    const speed = 50;

    if (i <= num) {
        section.innerHTML = i;
        setTimeout(function() {
            incNbrRec(i + 1, num, section);
        }, speed);
    }
}

export function gimmemoreDesktopNav() {
    const subNav = document.querySelector('.gimmemore-theme.desktop .sub-nav');
    if (!subNav) { return; }

    document.querySelector('.nav-desktop ul li a[href=sub_nav]').addEventListener('click', function (e) {
        e.preventDefault();
        const state = 'active';

        if (subNav.classList.contains(state)) {
            subNav.classList.remove(state);
        } else {
            subNav.classList.add(state);
        }
    });
}

export function lifelinesModal() {
    const bar = document.querySelector('.lifelines-bar');
    const modal = document.querySelector('.lifelines-modal');
    if (!bar || !modal) { return; }

    const requestModal = document.querySelector('.js-lifelines-modal-show');
    requestModal.addEventListener('click', function (e) {
        e.preventDefault();
        disableScroll();
        modal.classList.add('active');

        modal.querySelector('.js-lifelines-apply').addEventListener('click', function () {
            location.href = requestModal.href;
        });

        modal.querySelector('.js-lifelines-cancel').addEventListener('click', function () {
            enableScroll();
            modal.classList.remove('active');
        });
    });
}

export function toggleText() {
    let toggle = document.querySelector('.toggle-text');

    if (!toggle) { return; }

    toggle.addEventListener('click', function (e) {
        e.preventDefault();

        let points = document.querySelector('.points');
        let showMoreText = document.querySelector('.more-text');

        if (points.style.display === 'none') {
            showMoreText.style.display = 'none';
            points.style.display = 'inline';
            toggle.innerHTML = 'more';
        } else {
            showMoreText.style.display = 'inline';
            points.style.display = 'none';
            toggle.innerHTML = 'less';
        }
    });
}

export function getCookie(cookieName) {
    let name = cookieName + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }

    return '';
}

export function removeCookie(cookieName) {
    document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

export function accordionButtonsHandler() {
    const accordionButtons = document.querySelectorAll('.accordion-item');
    if(!accordionButtons) return;

    accordionButtons.forEach(button => {
        button.addEventListener('click', e => {
            e.preventDefault();
            const block = e.target.classList.contains('accordion-item') ? e.target : e.target.closest('.accordion-item');
            const target = block.dataset.accordionTarget;
            const targetDiv = document.getElementById(target);
            block.querySelector('.accordion-item-arrow').classList.toggle('rotate-180');
            if (targetDiv.style.maxHeight) {
                targetDiv.style.maxHeight = null;
            } else {
                targetDiv.style.maxHeight = targetDiv.scrollHeight + "px";
            }
        })
    });
}

export function shareModalHandler() {
    const shareModalId = 'shareModal';
    const modalElement = document.getElementById(`${shareModalId}`);

    if (!modalElement) return;

    const modalShowButton = document.querySelector('[data-share-modal-open]');
    modalShowButton.addEventListener('click', function (event) {
        event.preventDefault();
        modalElement.classList.toggle('hidden');
        disableAds();
    });

    const modalCloseButton = document.querySelector('[data-share-modal-close]');
    modalCloseButton.addEventListener('click', function (event) {
        event.preventDefault();
        modalElement.classList.toggle('hidden');
        refreshAds();
    });
}

export function playAgainUrlHandler() {
    const playAgainButton = document.querySelector('[data-play-again]');
    if (!playAgainButton || !location.pathname.includes('/complete')) return;

    playAgainButton.addEventListener('click', function (event) {
       event.preventDefault();
       location.href = location.protocol + '//' + location.hostname + location.pathname.substring(0, location.pathname.indexOf('/complete')) + '?jp=1';
    });
}

export function disableAds() {
    if (window.googletag === undefined) return;
    window.googletag.destroySlots();
}

export function refreshAds() {
    if (window.googletag === undefined || typeof window.initSlots !== 'function') return;

    setTimeout(function () {
        if (!isVisible(document.querySelector('[data-popup]'))) {
            requestManager.adserverRequestSent = false;
            initSlots();
            fetchHeaderBids();
        }
    }, 100);
}

export function closeAllPopups() {
    document.querySelectorAll('[data-popup]').forEach(item => item.classList.add('hidden'));
}

export function isVisible(el) {
    return !!el.offsetWidth && !!el.offsetHeight;
}

export function showItemsListWithDelay() {
    const itemsListVisibleByDelay = document.querySelectorAll('.items-visible-by-delay');
    if (!itemsListVisibleByDelay.length) return;

    const showItemWithDelay = item => {
        item.querySelectorAll('.hidden-item').forEach((element, i) => {
            let timeout = parseFloat((i + 1) * item.dataset.delaySeconds) * 1000;

            setTimeout(function () {
                element.classList.remove('hidden-item');
                element.classList.add('visible-item');
            }, timeout);
        });
    }

    itemsListVisibleByDelay.forEach(showItemWithDelay);
}

export function isPageReloaded() {
    const entry = performance.getEntriesByType("navigation")[0];
    return !!entry && entry.type === "reload";
}